import {
  customInstanceWithHeader,
  type ResponseWithHeaders,
} from '@fukuri-admins/apis/client/base/axiosInstance';
import {
  getGetApiV1ThreeLetterCodeClientAdminsUsersKey,
  getGetApiV1ThreeLetterCodeClientAdminsUsersUrl,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type {
  GetApiV1ThreeLetterCodeClientAdminsUsers200One,
  GetApiV1ThreeLetterCodeClientAdminsUsersParams,
} from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';
import type { KeyedMutator } from 'swr';

const fetcher = (
  threeLetterCode: string,
  apiParams: GetApiV1ThreeLetterCodeClientAdminsUsersParams
) =>
  customInstanceWithHeader<GetApiV1ThreeLetterCodeClientAdminsUsers200One>(
    getGetApiV1ThreeLetterCodeClientAdminsUsersUrl(threeLetterCode, apiParams),
    { method: 'GET' }
  );

type Args = {
  threeLetterCode: string;
  filter?: {
    email?: string;
    fullName?: string;
  };
  page?: string;
};

type IUseGetUsers = (args: Args) => {
  data: GetApiV1ThreeLetterCodeClientAdminsUsers200One;
  totalPage: number;
  totalCount: number;
  mutate: KeyedMutator<ResponseWithHeaders<GetApiV1ThreeLetterCodeClientAdminsUsers200One>>;
};

/**
 * 利用者一覧取得フック
 */
export const useGetUsers: IUseGetUsers = ({ threeLetterCode, filter, page }) => {
  const apiParams: GetApiV1ThreeLetterCodeClientAdminsUsersParams = {
    ...(filter?.email && { email: filter.email }),
    ...(filter?.fullName && { full_name: filter.fullName }),
    ...(page && !Number.isNaN(Number(page)) && { page: Number(page) }),
  };

  const { data, mutate } = useFetch<
    ResponseWithHeaders<GetApiV1ThreeLetterCodeClientAdminsUsers200One>
  >(
    getGetApiV1ThreeLetterCodeClientAdminsUsersKey(threeLetterCode, apiParams),
    () => fetcher(threeLetterCode, apiParams),
    { suspense: true }
  );

  const totalPage = Number(data.headers['total-pages']) || 0;
  const totalCount = Number(data.headers['total-count']) || 0;

  return {
    data: data.data,
    totalPage,
    totalCount,
    mutate,
  };
};
